import { Component, OnInit, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { User } from "../../entity/User";
import { AbstractAdvisorComponent } from "../abstract/advisor.component";
import { AnalyticsService } from "../../service/analytics.service";
import { NgxMaskDirective } from "ngx-mask";
import { ValidationService } from "../../service/validation.service";
import { firstValueFrom } from "rxjs";



@Component({
    selector: "contact-manager-dialog",
    templateUrl: "../../../html/incs/contact-manager-dialog.html",
    imports: [FormsModule, NgxMaskDirective, ReactiveFormsModule]
})
export class ContactManagerDialog extends AbstractAdvisorComponent {
    editContact: User;
    currentPhoneNumber: FormControl = new FormControl("");

    constructor(
        public dialogRef: MatDialogRef<ContactManagerDialog>,
        public validationService: ValidationService,
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
        }
        this.editContact = new User();
    }


    loadContact(id: number): void {
        firstValueFrom(this.generalService.getClient(id))
            .then((res: any) => {
                this.editContact = res.key;
                this.currentPhoneNumber.setValue(res.key.phone);
                this.refreshView();
            });
    }

    closeDialog(): void {
        this.dialogRef.close(0);
    }


    confirm(): void {
        this.clearErrors();
        if (this.editContact != null) {
            if (this.editContact.firstName == null || this.editContact.firstName.length == 0) {
                this.addError("FirstName");
            }
            if (this.editContact.lastName == null || this.editContact.lastName.length == 0) {
                this.addError("LastName");
            }
            if (this.editContact.email == null || this.editContact.email.length == 0) {
                this.addError("Email");
            }
            if (this.errorY().showError()) {
                this.setErrorText("Please enter the data requested above.");
                return;
            }

            if (!this.currentPhoneNumber.valid) {
                this.addError("Phone");
                this.setErrorText("Phone number is not correct.");
                return;
            }
            this.editContact.phone = this.currentPhoneNumber.value;
            if (this.editContact.id > 0) {
                this.generalService.updateUser(this.editContact, 0, null, false, true).subscribe(
                    {
                        next: (res: any) => {
                            if (res) {
                                this.dialogRef.close(0);
                            }
                        },
                        error: (err) => {
                            if (err.status == 400) {
                                this.setErrorText(err.error);
                            }
                        }
                    }
                );
            } else {
                this.generalService.registerUser(this.editContact, 0, null, null, null, true)
                    .subscribe({
                        next: (res: any) => {
                            if (res) {
                                this.dialogRef.close(res);
                            }
                        },
                        error: (err: any) => {
                            if (parseInt(err.status) == 400) {
                                this.addError("Email");
                                this.setErrorText(err.error);
                            }
                        }
                    });
            }
        }
    }
}